import React, {useEffect, useState} from "react";
import {
	AppBar,
	Drawer,
	Fab,
	Grid,
	Toolbar,
	Typography,
	withStyles
} from "@material-ui/core";
import {ReactComponent as ShareIcon} from "../../assets/images/icons/share.svg";
import {Share} from "../../components";
import Results from "./Results";
import styles from "./styles";
import {useSelector} from "react-redux";
import Carousel from "../../components/carousel/Carousel";
import {version} from "../../config";

const PoiRightMenu = ({data, classes}) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const {sidebar} = useSelector(state => state.helpers);
	const openSharePopup = Boolean(anchorEl);
	const handleShareOpen = event => {
		setAnchorEl(event.currentTarget);
	};
	const handleShareClose = () => {
		setAnchorEl(null);
	};
	return (
		<>
			<Drawer
				anchor="right"
				classes={{
					paper: classes.drawerPaperSideBar,
					root: sidebar.hidden ? classes.hidden : ""
				}}
				open={sidebar.opened}
				variant="persistent"
			>
				<div className={classes.toolbar}/>
				<div className={classes.wrapperPoiMedia}>
					<AppBar
						classes={{
							root: classes.resultHeaderAppBar
						}}
						color="inherit"
						position="static"
					>
						<Toolbar
							classes={{
								root: classes.resultHeaderToolbar
							}}
						>
							<Typography
								classes={{
									root: classes.resultHeaderTitle
								}}
								variant="h3"
							>
								<span className={classes.resultHeaderCount}>{data.length}</span>
								"Espaces"
							</Typography>
							<div className={classes.resultHeaderActions}>
								<Fab
									aria-haspopup="true"
									aria-owns={openSharePopup ? "simple-popper" : null}
									// buttonRef={this.setButtonRef}
									className={classes.resultHeaderButton}
									onClick={handleShareOpen}
									variant="extended"
								>
									<ShareIcon className={classes.resultHeaderIcon}/>
									<span>{"partage"}</span>
								</Fab>
								<Share
									element={anchorEl}
									onClose={handleShareClose}
									open={openSharePopup}
									url={window.location.href}
								/>
							</div>
						</Toolbar>
					</AppBar>
					<div className={classes.root}>
						<Grid container spacing={3}>
							<Grid item xs={12}>
								{data.map(item => {
										if (item.images.length) {
											return <Results key={item.id} classes={classes} data={item}/>
										}
									}
								)}
							</Grid>
						</Grid>
					</div>
				</div>
			</Drawer>
			{!version.office && sidebar ? <Carousel/> : null}
		</>
	);
};
export default withStyles(styles)(PoiRightMenu);
